import { makeStyles, Typography, Theme } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
  errorBadge: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    borderRadius: '50%',
    height: '20px',
    minWidth: '20px',
    padding: theme.spacing(0, '6px'),
    // right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
}))


export const ErrorCountBadge = (props: { errorCount: number}) => {
  const classes = useStyles()
  return !!props.errorCount && <Typography variant="caption" className={classes.errorBadge}>{props.errorCount}</Typography>
}
